import dayjs from 'dayjs';
import { communicationUtilities } from '@incentivegames/ig-frontend-common/lib/utilities/communicationUtilities';
import { IGame } from '@incentivegames/ig-types/lib/interfaces/apiContracts';

import routes from '../../../constants/routes';
import { ReactGACategories } from 'constants/appEnums';
import { dreamteamUtilities } from 'utilities/dreamteamUtilities';
import { dateTimeUtilities } from 'utilities/dateTimeUtilities';
import { postEntry } from 'store/actions/dreamteamActions';

export const HomeFunctions = {
  handleStartPlayingClick: (dispatch: any, uniqueId: string, history: any, currentGame: IGame | undefined, token?: string | undefined, promotion?: string): void => {
    const gameOpen = currentGame ? Date.now() > currentGame?.openTime : false;
    if (token && currentGame?.gameId) {
      if (gameOpen) {
        dreamteamUtilities.recordEventGA(ReactGACategories.nav, 'Entered new Game');
        dispatch(postEntry(token, currentGame?.gameId, uniqueId, promotion));
      } else {
        dreamteamUtilities.recordEventGA(ReactGACategories.nav, 'Went to existing game');
        history.push({
          pathname: routes.FIVES.route,
          search: window.location.search
        });
      }
    } else {
      dreamteamUtilities.recordEventGA(ReactGACategories.nav, 'Login message prompted');
      communicationUtilities.sendPostMessage.login();
    }
  },
  formatDateTime: (t: any, timeStamp: number) => {
    const dayJsTimeObject = dayjs(timeStamp);
    const day = t(dayJsTimeObject.format('ddd').toLowerCase());
    const date = dayJsTimeObject.format('D');
    const ordinal = t(dateTimeUtilities.getNthDay(parseInt(date)));
    const month = t(dayJsTimeObject.format('MMM').toLowerCase());
    const time = dayJsTimeObject.format('HH:mm');
    return `${day} ${date}${ordinal} ${month} ${time}`;
  },
  howToPlayClick: () => {
    communicationUtilities.sendPostMessage.howToPlay();
  },
  getLogoName: (): string => {
    const envLanguage = process.env.REACT_APP_LANGUAGE;
    const envRegion = process.env.REACT_APP_REGION;

    if (envLanguage === 'nl' || envRegion === 'nl') {
      return 'nl-logo';
    }
    if (envLanguage === 'bg' || envRegion === 'bg') {
      return 'bg-logo';
    }
    return 'logo';
  }
};
